function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import * as t from "leaflet";
function e() {
  return e = Object.assign ? Object.assign.bind() : function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, e.apply(this, arguments);
}
function r(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t, n(t, e);
}
function n(t, e) {
  return n = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, n(t, e);
}
function o() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (t) {
    return !1;
  }
}
function i(t, e, r) {
  return i = o() ? Reflect.construct.bind() : function (t, e, r) {
    var o = [null];
    o.push.apply(o, e);
    var i = new (Function.bind.apply(t, o))();
    return r && n(i, r.prototype), i;
  }, i.apply(null, arguments);
}
function s(t, e, r, n) {
  void 0 === e && (e = ""), void 0 === n && (n = {});
  var o = document.createElement(t);
  return e && (o.className = e), Object.keys(n).forEach(function (t) {
    if ("function" == typeof n[t]) {
      var e = 0 === t.indexOf("on") ? t.substr(2).toLowerCase() : t;
      o.addEventListener(e, n[t]);
    } else "html" === t ? o.innerHTML = n[t] : "text" === t ? o.innerText = n[t] : o.setAttribute(t, n[t]);
  }), r && r.appendChild(o), o;
}
function a(t) {
  t.preventDefault(), t.stopPropagation();
}
var l = function l() {
  return [].slice.call(arguments).filter(Boolean).join(" ").trim();
};
function c(t, e) {
  t && t.classList && (Array.isArray(e) ? e : [e]).forEach(function (e) {
    t.classList.contains(e) || t.classList.add(e);
  });
}
function u(t, e) {
  t && t.classList && (Array.isArray(e) ? e : [e]).forEach(function (e) {
    t.classList.contains(e) && t.classList.remove(e);
  });
}
var h,
  p = 13,
  d = 40,
  f = 38,
  m = [p, 27, d, f, 37, 39],
  v = /*#__PURE__*/function () {
    function t(t) {
      var e = this,
        r = t.handleSubmit,
        n = t.searchLabel,
        o = t.classNames,
        i = void 0 === o ? {} : o;
      this.container = void 0, this.form = void 0, this.input = void 0, this.handleSubmit = void 0, this.hasError = !1, this.container = s("div", l("geosearch", i.container)), this.form = s("form", ["", i.form].join(" "), this.container, {
        autocomplete: "none",
        onClick: a,
        onDblClick: a,
        touchStart: a,
        touchEnd: a
      }), this.input = s("input", ["glass", i.input].join(" "), this.form, {
        type: "text",
        placeholder: n || "search",
        onInput: this.onInput,
        onKeyUp: function onKeyUp(t) {
          return e.onKeyUp(t);
        },
        onKeyPress: function onKeyPress(t) {
          return e.onKeyPress(t);
        },
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        onClick: function onClick() {
          e.input.focus(), e.input.dispatchEvent(new Event("focus"));
        }
      }), this.handleSubmit = r;
    }
    var e = t.prototype;
    return e.onFocus = function () {
      c(this.form, "active");
    }, e.onBlur = function () {
      u(this.form, "active");
    }, e.onSubmit = function (t) {
      try {
        var e = this;
        return a(t), u(r = e.container, "error"), c(r, "pending"), Promise.resolve(e.handleSubmit({
          query: e.input.value
        })).then(function () {
          u(e.container, "pending");
        });
      } catch (t) {
        return Promise.reject(t);
      }
      var r;
    }, e.onInput = function () {
      this.hasError && (u(this.container, "error"), this.hasError = !1);
    }, e.onKeyUp = function (t) {
      27 === t.keyCode && (u(this.container, ["pending", "active"]), this.input.value = "", document.body.focus(), document.body.blur());
    }, e.onKeyPress = function (t) {
      t.keyCode === p && this.onSubmit(t);
    }, e.setQuery = function (t) {
      this.input.value = t;
    }, t;
  }(),
  g = /*#__PURE__*/function () {
    function t(t) {
      var e = this,
        r = t.handleClick,
        n = t.classNames,
        o = void 0 === n ? {} : n,
        i = t.notFoundMessage;
      this.handleClick = void 0, this.selected = -1, this.results = [], this.container = void 0, this.resultItem = void 0, this.notFoundMessage = void 0, this.onClick = function (t) {
        if ("function" == typeof e.handleClick) {
          var r = t.target;
          if (r && e.container.contains(r) && r.hasAttribute("data-key")) {
            var n = Number(r.getAttribute("data-key"));
            e.handleClick({
              result: e.results[n]
            });
          }
        }
      }, this.handleClick = r, this.notFoundMessage = i ? s("div", l(o.notfound), void 0, {
        html: i
      }) : void 0, this.container = s("div", l("results", o.resultlist)), this.container.addEventListener("click", this.onClick, !0), this.resultItem = s("div", l(o.item));
    }
    var e = t.prototype;
    return e.render = function (t, e) {
      var r = this;
      void 0 === t && (t = []), this.clear(), t.forEach(function (t, n) {
        var o = r.resultItem.cloneNode(!0);
        o.setAttribute("data-key", "" + n), o.innerHTML = e({
          result: t
        }), r.container.appendChild(o);
      }), t.length > 0 ? (c(this.container.parentElement, "open"), c(this.container, "active")) : this.notFoundMessage && (this.container.appendChild(this.notFoundMessage), c(this.container.parentElement, "open")), this.results = t;
    }, e.select = function (t) {
      return Array.from(this.container.children).forEach(function (e, r) {
        return r === t ? c(e, "active") : u(e, "active");
      }), this.selected = t, this.results[t];
    }, e.count = function () {
      return this.results ? this.results.length : 0;
    }, e.clear = function () {
      for (this.selected = -1; this.container.lastChild;) this.container.removeChild(this.container.lastChild);
      u(this.container.parentElement, "open"), u(this.container, "active");
    }, t;
  }(),
  y = {
    position: "topleft",
    style: "button",
    showMarker: !0,
    showPopup: !1,
    popupFormat: function popupFormat(t) {
      return "" + t.result.label;
    },
    resultFormat: function resultFormat(t) {
      return "" + t.result.label;
    },
    marker: {
      icon: t && t.Icon ? new t.Icon.Default() : void 0,
      draggable: !1
    },
    maxMarkers: 1,
    maxSuggestions: 5,
    retainZoomLevel: !1,
    animateZoom: !0,
    searchLabel: "Enter address",
    clearSearchLabel: "Clear search",
    notFoundMessage: "",
    messageHideDelay: 3e3,
    zoomLevel: 18,
    classNames: {
      container: "leaflet-bar leaflet-control leaflet-control-geosearch",
      button: "leaflet-bar-part leaflet-bar-part-single",
      resetButton: "reset",
      msgbox: "leaflet-bar message",
      form: "",
      input: "",
      resultlist: "",
      item: "",
      notfound: "leaflet-bar-notfound"
    },
    autoComplete: !0,
    autoCompleteDelay: 250,
    autoClose: !1,
    keepResult: !1,
    updateMap: !0,
    resetButton: "×"
  },
  b = "Leaflet must be loaded before instantiating the GeoSearch control",
  E = {
    options: e({}, y),
    classNames: e({}, y.classNames),
    initialize: function initialize(r) {
      var n,
        o,
        i,
        a,
        l = this;
      if (!t) throw new Error(b);
      if (!r.provider) throw new Error("Provider is missing from options");
      this.options = e({}, y, r), this.classNames = e({}, this.classNames, r.classNames), this.markers = new t.FeatureGroup(), this.classNames.container += " leaflet-geosearch-" + this.options.style, this.searchElement = new v({
        searchLabel: this.options.searchLabel,
        classNames: {
          container: this.classNames.container,
          form: this.classNames.form,
          input: this.classNames.input
        },
        handleSubmit: function handleSubmit(t) {
          return l.onSubmit(t);
        }
      }), this.button = s("a", this.classNames.button, this.searchElement.container, {
        title: this.options.searchLabel,
        href: "#",
        onClick: function onClick(t) {
          return l.onClick(t);
        }
      }), t.DomEvent.disableClickPropagation(this.button), this.resetButton = s("button", this.classNames.resetButton, this.searchElement.form, {
        text: this.options.resetButton,
        "aria-label": this.options.clearSearchLabel,
        onClick: function onClick() {
          "" === l.searchElement.input.value ? l.close() : l.clearResults(null, !0);
        }
      }), t.DomEvent.disableClickPropagation(this.resetButton), this.options.autoComplete && (this.resultList = new g({
        handleClick: function handleClick(t) {
          var e = t.result;
          l.searchElement.input.value = e.label, l.onSubmit({
            query: e.label,
            data: e
          });
        },
        classNames: {
          resultlist: this.classNames.resultlist,
          item: this.classNames.item,
          notfound: this.classNames.notfound
        },
        notFoundMessage: this.options.notFoundMessage
      }), this.searchElement.form.appendChild(this.resultList.container), this.searchElement.input.addEventListener("keyup", (n = function n(t) {
        return l.autoSearch(t);
      }, void 0 === (o = this.options.autoCompleteDelay) && (o = 250), void 0 === i && (i = !1), function () {
        var t = [].slice.call(arguments);
        a && clearTimeout(a), a = setTimeout(function () {
          a = null, i || n.apply(void 0, t);
        }, o), i && !a && n.apply(void 0, t);
      }), !0), this.searchElement.input.addEventListener("keydown", function (t) {
        return l.selectResult(t);
      }, !0), this.searchElement.input.addEventListener("keydown", function (t) {
        return l.clearResults(t, !0);
      }, !0)), this.searchElement.form.addEventListener("click", function (t) {
        t.preventDefault();
      }, !1);
    },
    onAdd: function onAdd(e) {
      var r = this.options,
        n = r.showMarker,
        o = r.style;
      if (this.map = e, n && this.markers.addTo(e), "bar" === o) {
        var i = e.getContainer().querySelector(".leaflet-control-container");
        this.container = s("div", "leaflet-control-geosearch leaflet-geosearch-bar"), this.container.appendChild(this.searchElement.form), i.appendChild(this.container);
      }
      return t.DomEvent.disableClickPropagation(this.searchElement.form), this.searchElement.container;
    },
    onRemove: function onRemove() {
      var t;
      return null == (t = this.container) || t.remove(), this;
    },
    open: function open() {
      var t = this.searchElement,
        e = t.input;
      c(t.container, "active"), e.focus();
    },
    close: function close() {
      u(this.searchElement.container, "active"), this.clearResults();
    },
    onClick: function onClick(t) {
      t.preventDefault(), t.stopPropagation(), this.searchElement.container.classList.contains("active") ? this.close() : this.open();
    },
    selectResult: function selectResult(t) {
      if (-1 !== [p, d, f].indexOf(t.keyCode)) if (t.preventDefault(), t.keyCode !== p) {
        var e = this.resultList.count() - 1;
        if (!(e < 0)) {
          var r = this.resultList.selected,
            n = t.keyCode === d ? r + 1 : r - 1,
            o = this.resultList.select(n < 0 ? e : n > e ? 0 : n);
          this.searchElement.input.value = o.label;
        }
      } else {
        var i = this.resultList.select(this.resultList.selected);
        this.onSubmit({
          query: this.searchElement.input.value,
          data: i
        });
      }
    },
    clearResults: function clearResults(t, e) {
      if (void 0 === e && (e = !1), !t || 27 === t.keyCode) {
        var r = this.options,
          n = r.autoComplete;
        !e && r.keepResult || (this.searchElement.input.value = "", this.markers.clearLayers()), n && this.resultList.clear();
      }
    },
    autoSearch: function autoSearch(t) {
      try {
        var e = this;
        if (m.indexOf(t.keyCode) > -1) return Promise.resolve();
        var r = t.target.value,
          n = e.options.provider,
          o = function () {
            if (r.length) return Promise.resolve(n.search({
              query: r
            })).then(function (t) {
              t = t.slice(0, e.options.maxSuggestions), e.resultList.render(t, e.options.resultFormat);
            });
            e.resultList.clear();
          }();
        return Promise.resolve(o && o.then ? o.then(function () {}) : void 0);
      } catch (t) {
        return Promise.reject(t);
      }
    },
    onSubmit: function onSubmit(t) {
      try {
        var e = this;
        return e.resultList.clear(), Promise.resolve(e.options.provider.search(t)).then(function (r) {
          r && r.length > 0 && e.showResult(r[0], t);
        });
      } catch (t) {
        return Promise.reject(t);
      }
    },
    showResult: function showResult(t, e) {
      var r = this.options,
        n = r.autoClose,
        o = r.updateMap,
        i = this.markers.getLayers();
      i.length >= this.options.maxMarkers && this.markers.removeLayer(i[0]);
      var s = this.addMarker(t, e);
      o && this.centerMap(t), this.map.fireEvent("geosearch/showlocation", {
        location: t,
        marker: s
      }), n && this.closeResults();
    },
    closeResults: function closeResults() {
      var t = this.searchElement.container;
      t.classList.contains("active") && u(t, "active"), this.clearResults();
    },
    addMarker: function addMarker(e, r) {
      var n = this,
        o = this.options,
        i = o.marker,
        s = o.showPopup,
        a = o.popupFormat,
        l = new t.Marker([e.y, e.x], i),
        c = e.label;
      return "function" == typeof a && (c = a({
        query: r,
        result: e
      })), l.bindPopup(c), this.markers.addLayer(l), s && l.openPopup(), i.draggable && l.on("dragend", function (t) {
        n.map.fireEvent("geosearch/marker/dragend", {
          location: l.getLatLng(),
          event: t
        });
      }), l;
    },
    centerMap: function centerMap(e) {
      var r = this.options,
        n = r.retainZoomLevel,
        o = r.animateZoom,
        i = e.bounds ? new t.LatLngBounds(e.bounds) : new t.LatLng(e.y, e.x).toBounds(10),
        s = i.isValid() ? i : this.markers.getBounds();
      !n && i.isValid() && !e.bounds || n || !i.isValid() ? this.map.setView(s.getCenter(), this.getZoom(), {
        animate: o
      }) : this.map.fitBounds(s, {
        animate: o
      });
    },
    getZoom: function getZoom() {
      var t = this.options,
        e = t.zoomLevel;
      return t.retainZoomLevel ? this.map.getZoom() : e;
    }
  };
function w() {
  if (!t) throw new Error(b);
  var e = t.Control.extend(E);
  return i(e, [].slice.call(arguments));
}
!function (t) {
  t[t.SEARCH = 0] = "SEARCH", t[t.REVERSE = 1] = "REVERSE";
}(h || (h = {}));
var x = /*#__PURE__*/function () {
    function t(t) {
      void 0 === t && (t = {}), this.options = void 0, this.options = t;
    }
    var r = t.prototype;
    return r.getParamString = function (t) {
      void 0 === t && (t = {});
      var r = e({}, this.options.params, t);
      return Object.keys(r).map(function (t) {
        return encodeURIComponent(t) + "=" + encodeURIComponent(r[t]);
      }).join("&");
    }, r.getUrl = function (t, e) {
      return t + "?" + this.getParamString(e);
    }, r.search = function (t) {
      try {
        var e = this,
          r = e.endpoint({
            query: t.query,
            type: h.SEARCH
          });
        return Promise.resolve(fetch(r)).then(function (t) {
          return Promise.resolve(t.json()).then(function (t) {
            return e.parse({
              data: t
            });
          });
        });
      } catch (t) {
        return Promise.reject(t);
      }
    }, t;
  }(),
  U = /*#__PURE__*/function (t) {
    function e() {
      for (var e, r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];
      return (e = t.call.apply(t, [this].concat(n)) || this).searchUrl = "https://restapi.amap.com/v3/geocode/geo", e;
    }
    r(e, t);
    var n = e.prototype;
    return n.endpoint = function (t) {
      var e = t.query,
        r = "string" == typeof e ? {
          address: e
        } : e;
      return r.output = "JSON", this.getUrl(this.searchUrl, r);
    }, n.parse = function (t) {
      var e;
      return (null != (e = t.data.geocodes) ? e : []).map(function (t) {
        return {
          x: Number(t.location.substring(0, t.location.indexOf(","))),
          y: Number(t.location.substring(t.location.indexOf(",") + 1)),
          label: t.formatted_address,
          bounds: null,
          raw: t
        };
      });
    }, e;
  }(x),
  k = /*#__PURE__*/function (t) {
    function e() {
      for (var e, r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];
      return (e = t.call.apply(t, [this].concat(n)) || this).searchUrl = "https://dev.virtualearth.net/REST/v1/Locations", e;
    }
    r(e, t);
    var n = e.prototype;
    return n.endpoint = function (t) {
      var e = t.query,
        r = "string" == typeof e ? {
          q: e
        } : e;
      return r.jsonp = t.jsonp, this.getUrl(this.searchUrl, r);
    }, n.parse = function (t) {
      return 0 === t.data.resourceSets.length ? [] : t.data.resourceSets[0].resources.map(function (t) {
        return {
          x: t.point.coordinates[1],
          y: t.point.coordinates[0],
          label: t.address.formattedAddress,
          bounds: [[t.bbox[0], t.bbox[1]], [t.bbox[2], t.bbox[3]]],
          raw: t
        };
      });
    }, n.search = function (t) {
      var e,
        r,
        n,
        o = t.query;
      try {
        var i = this,
          a = "BING_JSONP_CB_" + Date.now();
        return Promise.resolve((e = i.endpoint({
          query: o,
          jsonp: a
        }), r = a, n = s("script", null, document.body), n.setAttribute("type", "text/javascript"), new Promise(function (t) {
          window[r] = function (e) {
            n.remove(), delete window[r], t(e);
          }, n.setAttribute("src", e);
        }))).then(function (t) {
          return i.parse({
            data: t
          });
        });
      } catch (t) {
        return Promise.reject(t);
      }
    }, e;
  }(x),
  S = /*#__PURE__*/function (t) {
    function e(e) {
      var r;
      void 0 === e && (e = {}), (r = t.call(this, e) || this).searchUrl = void 0, r.reverseUrl = void 0;
      var n = "https://civildefense.fit.vutbr.cz";
      return r.searchUrl = e.searchUrl || n + "/search", r.reverseUrl = e.reverseUrl || n + "/reverse", r;
    }
    r(e, t);
    var n = e.prototype;
    return n.endpoint = function (t) {
      var e = t.query,
        r = t.type,
        n = "string" == typeof e ? {
          q: e
        } : e;
      return n.format = "json", this.getUrl(r === h.REVERSE ? this.reverseUrl : this.searchUrl, n);
    }, n.parse = function (t) {
      return (Array.isArray(t.data) ? t.data : [t.data]).map(function (t) {
        return {
          x: Number(t.lon),
          y: Number(t.lat),
          label: t.display_name,
          bounds: [[parseFloat(t.boundingbox[0]), parseFloat(t.boundingbox[2])], [parseFloat(t.boundingbox[1]), parseFloat(t.boundingbox[3])]],
          raw: t
        };
      });
    }, e;
  }(x),
  L = /*#__PURE__*/function (t) {
    function e() {
      for (var e, r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];
      return (e = t.call.apply(t, [this].concat(n)) || this).searchUrl = "https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/find", e;
    }
    r(e, t);
    var n = e.prototype;
    return n.endpoint = function (t) {
      var e = t.query,
        r = "string" == typeof e ? {
          text: e
        } : e;
      return r.f = "json", this.getUrl(this.searchUrl, r);
    }, n.parse = function (t) {
      return t.data.locations.map(function (t) {
        return {
          x: t.feature.geometry.x,
          y: t.feature.geometry.y,
          label: t.name,
          bounds: [[t.extent.ymin, t.extent.xmin], [t.extent.ymax, t.extent.xmax]],
          raw: t
        };
      });
    }, e;
  }(x),
  C = /*#__PURE__*/function (t) {
    function e(e) {
      var r;
      void 0 === e && (e = {}), (r = t.call(this, e) || this).searchUrl = void 0, r.reverseUrl = void 0;
      var n = "https://api-adresse.data.gouv.fr";
      return r.searchUrl = e.searchUrl || n + "/search", r.reverseUrl = e.reverseUrl || n + "/reverse", r;
    }
    r(e, t);
    var n = e.prototype;
    return n.endpoint = function (t) {
      var e = t.query;
      return this.getUrl(t.type === h.REVERSE ? this.reverseUrl : this.searchUrl, "string" == typeof e ? {
        q: e
      } : e);
    }, n.parse = function (t) {
      return t.data.features.map(function (t) {
        return {
          x: t.geometry.coordinates[0],
          y: t.geometry.coordinates[1],
          label: t.properties.label,
          bounds: null,
          raw: t
        };
      });
    }, e;
  }(x),
  P = /*#__PURE__*/function (t) {
    function e(e) {
      var r;
      void 0 === e && (e = {}), (r = t.call(this, e) || this).searchUrl = void 0, r.reverseUrl = void 0;
      var n = "https://api.geoapify.com/v1/geocode";
      return r.searchUrl = e.searchUrl || n + "/search", r.reverseUrl = e.reverseUrl || n + "/reverse", r;
    }
    r(e, t);
    var n = e.prototype;
    return n.endpoint = function (t) {
      var e = t.query,
        r = t.type,
        n = "string" == typeof e ? {
          text: e
        } : e;
      return n.format = "json", this.getUrl(r === h.REVERSE ? this.reverseUrl : this.searchUrl, n);
    }, n.parse = function (t) {
      return (Array.isArray(t.data.results) ? t.data.results : [t.data.results]).map(function (t) {
        var e = null;
        return t.bbox && (e = [[parseFloat(t.bbox.lat1), parseFloat(t.bbox.lon1)], [parseFloat(t.bbox.lat2), parseFloat(t.bbox.lon2)]]), {
          x: Number(t.lon),
          y: Number(t.lat),
          label: t.formatted,
          bounds: e,
          raw: t
        };
      });
    }, e;
  }(x),
  R = /*#__PURE__*/function (t) {
    function e(e) {
      var r;
      return void 0 === e && (e = {}), (r = t.call(this, e) || this).host = void 0, r.host = e.host || "http://localhost:4000", r;
    }
    r(e, t);
    var n = e.prototype;
    return n.endpoint = function (t) {
      var e = t.query;
      return t.type === h.REVERSE ? this.getUrl(this.host + "/v1/reverse", "string" == typeof e ? {} : e) : this.getUrl(this.host + "/v1/autocomplete", "string" == typeof e ? {
        text: e
      } : e);
    }, n.parse = function (t) {
      return t.data.features.map(function (t) {
        var e = {
          x: t.geometry.coordinates[0],
          y: t.geometry.coordinates[1],
          label: t.properties.label,
          bounds: null,
          raw: t
        };
        return Array.isArray(t.bbox) && 4 === t.bbox.length && (e.bounds = [[t.bbox[1], t.bbox[0]], [t.bbox[3], t.bbox[2]]]), e;
      });
    }, e;
  }(x),
  A = /*#__PURE__*/function (t) {
    function e(e) {
      return void 0 === e && (e = {}), e.host = "https://api.geocode.earth", t.call(this, e) || this;
    }
    return r(e, t), e;
  }(R);
function j(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
"function" == typeof SuppressedError && SuppressedError;
var I,
  N = /*@__PURE__*/j(function t(e, r) {
    if (e === r) return !0;
    if (e && r && "object" == _typeof(e) && "object" == _typeof(r)) {
      if (e.constructor !== r.constructor) return !1;
      var n, o, i;
      if (Array.isArray(e)) {
        if ((n = e.length) != r.length) return !1;
        for (o = n; 0 != o--;) if (!t(e[o], r[o])) return !1;
        return !0;
      }
      if (e.constructor === RegExp) return e.source === r.source && e.flags === r.flags;
      if (e.valueOf !== Object.prototype.valueOf) return e.valueOf() === r.valueOf();
      if (e.toString !== Object.prototype.toString) return e.toString() === r.toString();
      if ((n = (i = Object.keys(e)).length) !== Object.keys(r).length) return !1;
      for (o = n; 0 != o--;) if (!Object.prototype.hasOwnProperty.call(r, i[o])) return !1;
      for (o = n; 0 != o--;) {
        var s = i[o];
        if (!t(e[s], r[s])) return !1;
      }
      return !0;
    }
    return e != e && r != r;
  });
!function (t) {
  t[t.INITIALIZED = 0] = "INITIALIZED", t[t.LOADING = 1] = "LOADING", t[t.SUCCESS = 2] = "SUCCESS", t[t.FAILURE = 3] = "FAILURE";
}(I || (I = {}));
var O = /*#__PURE__*/function () {
  function O(_ref) {
    var t = _ref.apiKey,
      e = _ref.authReferrerPolicy,
      r = _ref.channel,
      n = _ref.client,
      _ref$id = _ref.id,
      o = _ref$id === void 0 ? "__googleMapsScriptId" : _ref$id,
      i = _ref.language,
      _ref$libraries = _ref.libraries,
      s = _ref$libraries === void 0 ? [] : _ref$libraries,
      a = _ref.mapIds,
      l = _ref.nonce,
      c = _ref.region,
      _ref$retries = _ref.retries,
      u = _ref$retries === void 0 ? 3 : _ref$retries,
      _ref$url = _ref.url,
      h = _ref$url === void 0 ? "https://maps.googleapis.com/maps/api/js" : _ref$url,
      p = _ref.version;
    _classCallCheck(this, O);
    if (this.callbacks = [], this.done = !1, this.loading = !1, this.errors = [], this.apiKey = t, this.authReferrerPolicy = e, this.channel = r, this.client = n, this.id = o || "__googleMapsScriptId", this.language = i, this.libraries = s, this.mapIds = a, this.nonce = l, this.region = c, this.retries = u, this.url = h, this.version = p, O.instance) {
      if (!N(this.options, O.instance.options)) throw new Error("Loader must not be called again with different options. ".concat(JSON.stringify(this.options), " !== ").concat(JSON.stringify(O.instance.options)));
      return O.instance;
    }
    O.instance = this;
  }
  _createClass(O, [{
    key: "options",
    get: function get() {
      return {
        version: this.version,
        apiKey: this.apiKey,
        channel: this.channel,
        client: this.client,
        id: this.id,
        libraries: this.libraries,
        language: this.language,
        region: this.region,
        mapIds: this.mapIds,
        nonce: this.nonce,
        url: this.url,
        authReferrerPolicy: this.authReferrerPolicy
      };
    }
  }, {
    key: "status",
    get: function get() {
      return this.errors.length ? I.FAILURE : this.done ? I.SUCCESS : this.loading ? I.LOADING : I.INITIALIZED;
    }
  }, {
    key: "failed",
    get: function get() {
      return this.done && !this.loading && this.errors.length >= this.retries + 1;
    }
  }, {
    key: "createUrl",
    value: function createUrl() {
      var t = this.url;
      return t += "?callback=__googleMapsCallback&loading=async", this.apiKey && (t += "&key=".concat(this.apiKey)), this.channel && (t += "&channel=".concat(this.channel)), this.client && (t += "&client=".concat(this.client)), this.libraries.length > 0 && (t += "&libraries=".concat(this.libraries.join(","))), this.language && (t += "&language=".concat(this.language)), this.region && (t += "&region=".concat(this.region)), this.version && (t += "&v=".concat(this.version)), this.mapIds && (t += "&map_ids=".concat(this.mapIds.join(","))), this.authReferrerPolicy && (t += "&auth_referrer_policy=".concat(this.authReferrerPolicy)), t;
    }
  }, {
    key: "deleteScript",
    value: function deleteScript() {
      var t = document.getElementById(this.id);
      t && t.remove();
    }
  }, {
    key: "load",
    value: function load() {
      return this.loadPromise();
    }
  }, {
    key: "loadPromise",
    value: function loadPromise() {
      var _this = this;
      return new Promise(function (t, e) {
        _this.loadCallback(function (r) {
          r ? e(r.error) : t(window.google);
        });
      });
    }
  }, {
    key: "importLibrary",
    value: function importLibrary(t) {
      return this.execute(), google.maps.importLibrary(t);
    }
  }, {
    key: "loadCallback",
    value: function loadCallback(t) {
      this.callbacks.push(t), this.execute();
    }
  }, {
    key: "setScript",
    value: function setScript() {
      var _this2 = this;
      var t, e;
      if (document.getElementById(this.id)) return void this.callback();
      var r = {
        key: this.apiKey,
        channel: this.channel,
        client: this.client,
        libraries: this.libraries.length && this.libraries,
        v: this.version,
        mapIds: this.mapIds,
        language: this.language,
        region: this.region,
        authReferrerPolicy: this.authReferrerPolicy
      };
      Object.keys(r).forEach(function (t) {
        return !r[t] && delete r[t];
      }), (null === (e = null === (t = null === window || void 0 === window ? void 0 : window.google) || void 0 === t ? void 0 : t.maps) || void 0 === e ? void 0 : e.importLibrary) || function (t) {
        var e,
          r,
          n,
          o = "The Google Maps JavaScript API",
          i = "google",
          s = "importLibrary",
          a = "__ib__",
          l = document,
          c = window;
        c = c[i] || (c[i] = {});
        var u = c.maps || (c.maps = {}),
          h = new Set(),
          p = new URLSearchParams(),
          d = function d() {
            return e || (e = new Promise(function (s, c) {
              return d = _this2, m = /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
                var d;
                return _regeneratorRuntime().wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return r = l.createElement("script");
                    case 2:
                      r.id = this.id;
                      p.set("libraries", _toConsumableArray(h) + "");
                      _context.t0 = _regeneratorRuntime().keys(t);
                    case 5:
                      if ((_context.t1 = _context.t0()).done) {
                        _context.next = 10;
                        break;
                      }
                      n = _context.t1.value;
                      p.set(n.replace(/[A-Z]/g, function (t) {
                        return "_" + t[0].toLowerCase();
                      }), t[n]);
                      _context.next = 5;
                      break;
                    case 10:
                      p.set("callback", i + ".maps." + a), r.src = this.url + "?" + p, u[a] = s, r.onerror = function () {
                        return e = c(Error(o + " could not load."));
                      }, r.nonce = this.nonce || (null === (d = l.querySelector("script[nonce]")) || void 0 === d ? void 0 : d.nonce) || "", l.head.append(r);
                    case 11:
                    case "end":
                      return _context.stop();
                  }
                }, _callee, this);
              }), new ((f = void 0) || (f = Promise))(function (t, e) {
                function r(t) {
                  try {
                    o(m.next(t));
                  } catch (t) {
                    e(t);
                  }
                }
                function n(t) {
                  try {
                    o(m.throw(t));
                  } catch (t) {
                    e(t);
                  }
                }
                function o(e) {
                  var o;
                  e.done ? t(e.value) : (o = e.value, o instanceof f ? o : new f(function (t) {
                    t(o);
                  })).then(r, n);
                }
                o((m = m.apply(d, [])).next());
              });
              var d, f, m;
            }));
          };
        u[s] ? console.warn(o + " only loads once. Ignoring:", t) : u[s] = function (t) {
          for (var _len = arguments.length, e = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            e[_key - 1] = arguments[_key];
          }
          return h.add(t) && d().then(function () {
            return u[s].apply(u, [t].concat(e));
          });
        };
      }(r);
      var n = this.libraries.map(function (t) {
        return _this2.importLibrary(t);
      });
      n.length || n.push(this.importLibrary("core")), Promise.all(n).then(function () {
        return _this2.callback();
      }, function (t) {
        var e = new ErrorEvent("error", {
          error: t
        });
        _this2.loadErrorCallback(e);
      });
    }
  }, {
    key: "reset",
    value: function reset() {
      this.deleteScript(), this.done = !1, this.loading = !1, this.errors = [], this.onerrorEvent = null;
    }
  }, {
    key: "resetIfRetryingFailed",
    value: function resetIfRetryingFailed() {
      this.failed && this.reset();
    }
  }, {
    key: "loadErrorCallback",
    value: function loadErrorCallback(t) {
      var _this3 = this;
      if (this.errors.push(t), this.errors.length <= this.retries) {
        var _t = this.errors.length * Math.pow(2, this.errors.length);
        console.error("Failed to load Google Maps script, retrying in ".concat(_t, " ms.")), setTimeout(function () {
          _this3.deleteScript(), _this3.setScript();
        }, _t);
      } else this.onerrorEvent = t, this.callback();
    }
  }, {
    key: "callback",
    value: function callback() {
      var _this4 = this;
      this.done = !0, this.loading = !1, this.callbacks.forEach(function (t) {
        t(_this4.onerrorEvent);
      }), this.callbacks = [];
    }
  }, {
    key: "execute",
    value: function execute() {
      if (this.resetIfRetryingFailed(), this.done) this.callback();else {
        if (window.google && window.google.maps && window.google.maps.version) return console.warn("Google Maps already loaded outside @googlemaps/js-api-loader.This may result in undesirable behavior as options and script parameters may not match."), void this.callback();
        this.loading || (this.loading = !0, this.setScript());
      }
    }
  }]);
  return O;
}();
var F = /*#__PURE__*/function (t) {
    function e(e) {
      var r;
      return (r = t.call(this, e) || this).loader = null, r.geocoder = null, "undefined" != typeof window && (r.loader = new O(e).load().then(function (t) {
        var e = new t.maps.Geocoder();
        return r.geocoder = e, e;
      })), r;
    }
    r(e, t);
    var n = e.prototype;
    return n.endpoint = function (t) {
      throw new Error("Method not implemented.");
    }, n.parse = function (t) {
      return t.data.results.map(function (t) {
        var e = t.geometry.location.toJSON(),
          r = e.lat,
          n = e.lng,
          o = t.geometry.viewport.toJSON();
        return {
          x: n,
          y: r,
          label: t.formatted_address,
          bounds: [[o.south, o.west], [o.north, o.east]],
          raw: t
        };
      });
    }, n.search = function (t) {
      try {
        var e = function e(_e) {
            if (!_e) throw new Error("GoogleMaps GeoCoder is not loaded. Are you trying to run this server side?");
            return Promise.resolve(_e.geocode({
              address: t.query
            }, function (t) {
              return {
                results: t
              };
            }).catch(function (t) {
              return "ZERO_RESULTS" !== t.code && console.error(t.code + ": " + t.message), {
                results: []
              };
            })).then(function (t) {
              return r.parse({
                data: t
              });
            });
          },
          r = this,
          n = r.geocoder;
        return Promise.resolve(n ? e(n) : Promise.resolve(r.loader).then(e));
      } catch (t) {
        return Promise.reject(t);
      }
    }, e;
  }(x),
  q = /*#__PURE__*/function (t) {
    function e() {
      for (var e, r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];
      return (e = t.call.apply(t, [this].concat(n)) || this).searchUrl = "https://maps.googleapis.com/maps/api/geocode/json", e;
    }
    r(e, t);
    var n = e.prototype;
    return n.endpoint = function (t) {
      var e = t.query;
      return this.getUrl(this.searchUrl, "string" == typeof e ? {
        address: e
      } : e);
    }, n.parse = function (t) {
      return t.data.results.map(function (t) {
        return {
          x: t.geometry.location.lng,
          y: t.geometry.location.lat,
          label: t.formatted_address,
          bounds: [[t.geometry.viewport.southwest.lat, t.geometry.viewport.southwest.lng], [t.geometry.viewport.northeast.lat, t.geometry.viewport.northeast.lng]],
          raw: t
        };
      });
    }, e;
  }(x),
  M = /*#__PURE__*/function (t) {
    function e() {
      for (var e, r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];
      return (e = t.call.apply(t, [this].concat(n)) || this).searchUrl = "https://geocode.search.hereapi.com/v1/geocode", e;
    }
    r(e, t);
    var n = e.prototype;
    return n.endpoint = function (t) {
      var e = t.query;
      return this.getUrl(this.searchUrl, "string" == typeof e ? {
        q: e
      } : e);
    }, n.parse = function (t) {
      return t.data.items.filter(function (t) {
        return void 0 !== t.position;
      }).map(function (t) {
        return {
          x: t.position.lng,
          y: t.position.lat,
          label: t.address.label,
          bounds: null,
          raw: t
        };
      });
    }, e;
  }(x),
  _ = /*#__PURE__*/function (t) {
    function e(e) {
      var r;
      void 0 === e && (e = {}), (r = t.call(this, e) || this).searchUrl = void 0, r.reverseUrl = void 0;
      var n = "https://nominatim.openstreetmap.org";
      return r.searchUrl = e.searchUrl || n + "/search", r.reverseUrl = e.reverseUrl || n + "/reverse", r;
    }
    r(e, t);
    var n = e.prototype;
    return n.endpoint = function (t) {
      var e = t.query,
        r = t.type,
        n = "string" == typeof e ? {
          q: e
        } : e;
      return n.format = "json", this.getUrl(r === h.REVERSE ? this.reverseUrl : this.searchUrl, n);
    }, n.parse = function (t) {
      return (Array.isArray(t.data) ? t.data : [t.data]).map(function (t) {
        return {
          x: Number(t.lon),
          y: Number(t.lat),
          label: t.display_name,
          bounds: [[parseFloat(t.boundingbox[0]), parseFloat(t.boundingbox[2])], [parseFloat(t.boundingbox[1]), parseFloat(t.boundingbox[3])]],
          raw: t
        };
      });
    }, e;
  }(x),
  B = /*#__PURE__*/function (t) {
    function n(r) {
      return t.call(this, e({}, r, {
        searchUrl: "https://locationiq.org/v1/search.php",
        reverseUrl: "https://locationiq.org/v1/reverse.php"
      })) || this;
    }
    return r(n, t), n.prototype.parse = function (e) {
      return e.data.error ? [] : t.prototype.parse.call(this, e);
    }, n;
  }(_),
  D = /*#__PURE__*/function (t) {
    function e(e) {
      var r;
      return void 0 === e && (e = {}), (r = t.call(this, e) || this).searchUrl = void 0, r.searchUrl = e.searchUrl || "https://a.tiles.mapbox.com/v4/geocode/mapbox.places/", r;
    }
    r(e, t);
    var n = e.prototype;
    return n.endpoint = function (t) {
      return this.getUrl("" + this.searchUrl + t.query + ".json");
    }, n.parse = function (t) {
      return (Array.isArray(t.data.features) ? t.data.features : []).map(function (t) {
        var e = null;
        return t.bbox && (e = [[parseFloat(t.bbox[1]), parseFloat(t.bbox[0])], [parseFloat(t.bbox[3]), parseFloat(t.bbox[2])]]), {
          x: Number(t.center[0]),
          y: Number(t.center[1]),
          label: t.place_name ? t.place_name : t.text,
          bounds: e,
          raw: t
        };
      });
    }, e;
  }(x),
  G = /*#__PURE__*/function (t) {
    function e() {
      for (var e, r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];
      return (e = t.call.apply(t, [this].concat(n)) || this).searchUrl = "https://api.opencagedata.com/geocode/v1/json", e;
    }
    r(e, t);
    var n = e.prototype;
    return n.endpoint = function (t) {
      var e = t.query,
        r = "string" == typeof e ? {
          q: e
        } : e;
      return r.format = "json", this.getUrl(this.searchUrl, r);
    }, n.parse = function (t) {
      return t.data.results.map(function (t) {
        var e = null;
        return t.bounds && (e = [[t.bounds.southwest.lat, t.bounds.southwest.lng], [t.bounds.northeast.lat, t.bounds.northeast.lng]]), {
          x: t.geometry.lng,
          y: t.geometry.lat,
          label: t.formatted,
          bounds: e,
          raw: t
        };
      });
    }, n.search = function (e) {
      try {
        return Promise.resolve(e.query.length < 2 ? [] : t.prototype.search.call(this, e));
      } catch (t) {
        return Promise.reject(t);
      }
    }, e;
  }(x);
export { U as AMapProvider, k as BingProvider, S as CivilDefenseMapProvider, L as EsriProvider, C as GeoApiFrProvider, w as GeoSearchControl, P as GeoapifyProvider, A as GeocodeEarthProvider, F as GoogleProvider, M as HereProvider, x as JsonProvider, q as LegacyGoogleProvider, B as LocationIQProvider, D as MapBoxProvider, G as OpenCageProvider, _ as OpenStreetMapProvider, R as PeliasProvider, w as SearchControl, v as SearchElement };